import { Button, Spinner } from 'reactstrap';
import TotalPrice from './TotalPrice';

const ReviewContent = ({
  checkoutUrl,
  plan: { seats, stripePrice },
  onEditPlan,
  team,
}) => {
  return (
    <div>
      <h1>Review: {team.name}</h1>
      <TotalPrice
        seats={seats}
        stripePrice={stripePrice}
        onEditPlan={onEditPlan}
      />
      <p className="font-tiny">
        By clicking Next below you agree to the{' '}
        <a href="https://www.overyield.com/terms-of-service">
          Terms of Service
        </a>
        .
      </p>
      <Button
        color={checkoutUrl ? 'primary' : 'secondary'}
        block
        onClick={() => {
          window.location.href = checkoutUrl;
        }}
        disabled={!checkoutUrl}
      >
        {checkoutUrl ? (
          'Next: Payment'
        ) : (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        )}
      </Button>
    </div>
  );
};

export default ReviewContent;
